export default [
  {
    path: '/task',
    name: 'task',
    component: () => import('@/views/task/index.vue'),
    meta: { title: 'app_task', pageLevel: 2 }
  }
]
